// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1z6d7","legacyBtn":"MutateMid_legacyBtn__2OTJS"};